import { lazy, StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './styles.css'
import './theme.css'
import './activities.css'
import './competition.css'
import './campaign-carousel.css'
import './about.css'
import './world-stage.css'
import './burgundy-theme.css'
import './responsive.css'
import './awards-and-leadership.css'
import './video-controls.css'

const Admin = lazy(() => import('./Admin'))
const isAdmin = /^\/admin\/?$/.test(window.location.pathname)
if (isAdmin) {
  document.title = 'จัดการผู้สมัคร | EMPRESS OF WELLNESS 2026'
  const robots = document.createElement('meta')
  robots.name = 'robots'
  robots.content = 'noindex, nofollow'
  document.head.append(robots)
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {isAdmin ? <Suspense fallback={<p role="status" style={{ padding: '2rem' }}>กำลังเปิดหน้าจัดการผู้สมัคร…</p>}><Admin /></Suspense> : <App />}
  </StrictMode>,
)
